import React from "react";

// Bootstrap components
import { Form, Row, Col, InputGroup } from "react-bootstrap";
import DateRange from "@material-ui/icons/DateRange";
import moment from "moment";
import "bootstrap-daterangepicker/daterangepicker.css";
import PropTypes from "prop-types";
import validation from "react-validation-mixin";
import strategy from "joi-validation-strategy";
import Joi from "joi";
import APIUtil from "./../../../config/APIUtil";
import UrlConstants from "./../../../config/UrlConstants";
import InputMask from "react-input-mask";
import DatePicker from "react-date-picker";
import { getToday } from "./../../Common/Common";
import * as message from "./../../../config/CommonMessages";

var todayDate = new Date();
var minDate =
  todayDate.getMonth() +
  1 +
  "/" +
  todayDate.getDate() +
  "/" +
  todayDate.getFullYear();

class PersonalInfo extends React.Component {
  constructor(props) {
    super(props);

    this.setStartDate = this.setStartDate.bind(this);
    this.setAgentDate = this.setAgentDate.bind(this);
    this.state = {
      startDate: props.getUserData().licenseExpirationDate,
      agentDate: props.getUserData().agentLicenseExpirationDate,
      firstname: props.getUserData().firstname,
      username: props.getUserData().username,
      lastname: props.getUserData().lastname,
      email: props.getUserData().email,
      recoveryEmail: props.getUserData().recoveryEmail,
      password: props.getUserData().password,
      confirmPassword: props.getUserData().confirmPassword,
      mobileNumber: props.getUserData().mobileNumber,
      otherNumber: props.getUserData().otherNumber,
      knowAboutUs: props.getUserData().knowAboutUs,
      referralCode: props.getUserData().referralCode,
      isEmailExist: false,
      isEmailDeleted: false,
      socialMediaHandles: {
        facebook: props.getUserData().socialMediaHandles.facebook,
        twitter: props.getUserData().socialMediaHandles.twitter,
        instagram: props.getUserData().socialMediaHandles.instagram,
        zillow: props.getUserData().socialMediaHandles.zillow,
        realtor: props.getUserData().socialMediaHandles.realtor,
      },
      isBuyerAgentInviteByAdmin: props.getUserData().isBuyerAgentInviteByAdmin,
      userNameDuplicate: false,
      mobileDuplicate: false,
      validFirstName: false,
      validLastName: false,
      validPassword: false,
    };

    this.validatorTypes = function() {
      var base = Joi.object().keys({
        email: Joi.string()
          .regex(new RegExp("^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$"))
          .required()
          .label("Email ID"),
        firstname: Joi.string()
          .required()
          .label("First Name"),
        username: Joi.string()
          .required()
          .regex(new RegExp("^[a-z][a-z0-9@._]*$"))
          .label("Username"),
        lastname: Joi.string()
          .required()
          .label("Last Name"),
        recoveryEmail: Joi.string()
          .regex(new RegExp("^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$"))
          .required()
          .label("Confirm Email ID"),
        recoveryEmail: Joi.ref("email"),
        password: Joi.string()
          .min(6)
          .max(30)
          .required()
          .label("Password"),
        confirmPassword: Joi.string()
          .min(6)
          .max(30)
          .required(),
        confirmPassword: Joi.ref("password"),
        mobileNumber: Joi.string()
          .regex(new RegExp("^[0-9]{3}-[0-9]{3}-[0-9]{4}?$"))
          .required()
          .label("Mobile No"),
        otherNumber: Joi.string()
          .allow("")
          .regex(new RegExp("^[0-9]{3}-[0-9]{3}-[0-9]{4}?$"))
          .label("Phone No. (Office)"),
        brokerLicenseNo: Joi.string().label("Broker License No"),
        socialMediaHandles: Joi.object().keys({
          facebook: Joi.string()
            .allow("")
            .regex(
              new RegExp(
                /(http(s)?):\/\/(www\.)|[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/
              )
            )
            .label("Facebook URL"),
          twitter: Joi.string()
            .allow("")
            .regex(
              new RegExp(
                /(http(s)?):\/\/(www\.)|[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/
              )
            )
            .label("Twitter URL"),
          zillow: Joi.string()
            .allow("")
            .regex(
              new RegExp(
                /(http(s)?):\/\/(www\.)|[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/
              )
            )
            .label("Zillow URL"),
          realtor: Joi.string()
            .allow("")
            .regex(
              new RegExp(
                /(http(s)?):\/\/(www\.)|[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/
              )
            )
            .label("Realtor.com URL"),
        }),
      });

      return base;
    };

    this.getValidatorData = this.getValidatorData.bind(this);
    this.renderHelpText = this.renderHelpText.bind(this);
    this.isValidated = this.isValidated.bind(this);
  }

  /**
   * @desc get validator data
   * this object is used to perform validation based on set joi validation schema
   */
  getValidatorData() {
    return {
      firstname: this.props.getUserData().firstname,
      username: this.props.getUserData().username,
      lastname: this.props.getUserData().lastname,
      email: this.props.getUserData().email,
      recoveryEmail: this.props.getUserData().recoveryEmail,
      password: this.props.getUserData().password,
      confirmPassword: this.props.getUserData().confirmPassword,
      mobileNumber: this.props.getUserData().mobileNumber,
      otherNumber: this.props.getUserData().otherNumber,
      knowAboutUs: this.props.getUserData().knowAboutUs,
      referralCode: this.props.getUserData().referralCode,
      socialMediaHandles: {
        facebook: this.props.getUserData().socialMediaHandles.facebook,
        twitter: this.props.getUserData().socialMediaHandles.twitter,
        instagram: this.props.getUserData().socialMediaHandles.instagram,
        zillow: this.props.getUserData().socialMediaHandles.zillow,
        realtor: this.props.getUserData().socialMediaHandles.realtor,
      },
    };
  }

  /**
   * @desc check form is validate or not
   */
  isValidated() {
    return new Promise((resolve, reject) => {
      this.props.validate((error) => {
        if (
          error ||
          this.state.isEmailExist ||
          this.state.isEmailDeleted ||
          this.state.userNameDuplicate ||
          this.state.mobileDuplicate ||
          this.state.validFirstName ||
          this.state.validLastName ||
          this.state.validPassword
        ) {
          reject();
          return;
        }
        resolve();
      });
    });
  }

  renderHelpText(message, id) {
    return (
      <div className="val-err-tooltip" key={id}>
        <span>{message}</span>
      </div>
    );
  }

  checkNameValidation(value) {
    // console.log("checkNameValidation value", value);
    let nameRegEx = /^[A-Za-z '-]{0,50}$/;
    if (nameRegEx.test(value)) {
      // console.log("matched");
      return true;
    } else {
      // console.log("not matched");
      return false;
    }
  }

  checkPasswordValidation(value) {
    // console.log("password value", value);
    let nameRegEx = /^\S*$/;
    if (nameRegEx.test(value)) {
      // console.log("password matched");
      return true;
    } else {
      // console.log("password not matched");
      return false;
    }
  }

  /**
   * @desc on change event of input tags and set data to state and also updating data in parent component
   */
  onChange(event) {
    let val = event.target.value;
    // console.log("on change val", val);
    if (event.target.name === "firstname") {
      !this.checkNameValidation(val)
        ? this.setState({ validFirstName: true })
        : this.setState({ validFirstName: false });
    }
    if (event.target.name === "lastname") {
      !this.checkNameValidation(val)
        ? this.setState({ validLastName: true })
        : this.setState({ validLastName: false });
    }

    if (event.target.name === "password") {
      !this.checkPasswordValidation(val)
        ? this.setState({ validPassword: true })
        : this.setState({ validPassword: false });
    }

    if (event.target.name === "email") {
      this.checkEmailExist(val);
    }

    if (event.target.name === "username") {
      // console.log("OK", val);
      this.checkUserNameIsunique(val);
      // this.checkEmailExist(val);
    }

    if (event.target.name === "mobileNumber") {
      var mob = val.replace(/-/g, "");
      // console.log("OK at mobile", mob.length);
      if (mob.length === 10) {
        this.CheckMobileunique(mob);
      } else {
        this.setState({ mobileDuplicate: false });
      }
    }

    if (event.target.name === "socialMediaHandles.facebook") {
      let socials = this.state.socialMediaHandles;
      socials.facebook = val;
      this.setState({ socialMediaHandles: socials });
      this.props.updateUserData("socialMediaHandles", socials);
    } else if (event.target.name === "socialMediaHandles.twitter") {
      let socials = this.state.socialMediaHandles;
      socials.twitter = val;
      this.setState({ socialMediaHandles: socials });
      this.props.updateUserData("socialMediaHandles", socials);
    } else if (event.target.name === "socialMediaHandles.zillow") {
      let socials = this.state.socialMediaHandles;
      socials.zillow = val;
      this.setState({ socialMediaHandles: socials });
      this.props.updateUserData("socialMediaHandles", socials);
    } else if (event.target.name === "socialMediaHandles.realtor") {
      let socials = this.state.socialMediaHandles;
      socials.realtor = val;
      this.setState({ socialMediaHandles: socials });
      this.props.updateUserData("socialMediaHandles", socials);
    } else {
      this.setState({ [event.target.name]: val });
      this.props.updateUserData(event.target.name, val);
    }
  }

  setStartDate(date) {
    this.setState({
      startDate: moment(date),
    });
    let selDate = moment(date)
      .local()
      .format("YYYY-MM-DD");
    this.props.updateUserData("licenseExpirationDate", selDate);
  }

  setAgentDate(date) {
    this.setState({
      agentDate: moment(date),
    });
    let selDate = moment(date)
      .local()
      .format("YYYY-MM-DD");
    this.props.updateUserData("agentLicenseExpirationDate", selDate);
  }
  /**
   * @desc get error message for given field from errlist from validator
   */
  getErrorMsg(field, errsList) {
    var err = "";

    if (
      field === "firstname" ||
      field === "lastname" ||
      field === "brokerLicenseNo" ||
      field === "username"
    ) {
      if (
        errsList[field] !== undefined &&
        errsList[field] !== null &&
        errsList[field] !== ""
      ) {
        if (field === "firstname") {
          err = message.ENTER_FIRST_NAME;
        }

        if (field === "lastname") {
          err = message.ENTER_LAST_NAME;
        }
        if (field === "brokerLicenseNo") {
          err = message.ENTER_BROKER_LICENSE;
        }
      }
    }

    if (field === "username") {
      if (
        errsList[field] !== undefined &&
        errsList[field] !== null &&
        errsList[field] !== ""
      ) {
        // console.log("errsList[field].length", errsList[field].length);

        if (errsList[field].length == 2) {
          err = message.ENTER_USER_NAME;
        }
        if (errsList[field].length === 1) {
          err = message.ENTER_VALID_USER_NAME;
        }
      }
    }
    if (field === "email") {
      if (
        errsList[field] !== undefined &&
        errsList[field] !== null &&
        errsList[field] !== ""
      ) {
        if (errsList[field].length === 2) {
          err = message.ENTER_EMAIL;
        }
        if (errsList[field].length === 1) {
          err = message.ENTER_VALID_EMAIL;
        }
      }
    }

    if (field === "password") {
      if (
        errsList[field] !== undefined &&
        errsList[field] !== null &&
        errsList[field] !== ""
      ) {
        if (errsList[field].length === 2) {
          err = message.ENTER_PASSWORD;
        }
        if (errsList[field].length === 1) {
          err = message.PASSWORD_LENGTH;
        }
      }
    }
    if (field === "confirmPassword") {
      if (
        errsList[field] !== undefined &&
        errsList[field] !== null &&
        errsList[field] !== ""
      ) {
        if (errsList[field].length === 2) {
          err = message.CONFIRM_PASSWORD;
        }
        if (errsList[field].length === 1) {
          err = message.CONFIRM_PASSWORD_MATCH;
        }
      }
    }

    if (field === "recoveryEmail") {
      if (
        errsList[field] !== undefined &&
        errsList[field] !== null &&
        errsList[field] !== ""
      ) {
        if (errsList[field].length === 2) {
          err = message.ENTER_CONFIRM_EMAIL;
        }
        if (errsList[field].length === 1) {
          err = message.CONFIRM_EMAIL_SAME_AS_EMAIL;
        }
      }
    }

    if (field === "mobileNumber") {
      if (
        errsList[field] !== undefined &&
        errsList[field] !== null &&
        errsList[field] !== ""
      ) {
        if (errsList[field].length === 2) {
          err = message.ENTER_MOBILE_NUMBER;
        }
        if (errsList[field].length === 1) {
          err = message.MOBILE_10_DIGIT;
        }
      }
    }

    if (field === "otherNumber") {
      if (
        errsList[field] !== undefined &&
        errsList[field] !== null &&
        errsList[field] !== ""
      ) {
        if (errsList[field].length === 2) {
          err = message.ENTER_PHONE;
        }
        if (errsList[field].length === 1) {
          err = message.PHONE_10_DIGIT;
        }
      }
    }

    if (field === "facebook") {
      if (
        errsList["socialMediaHandles,facebook"] !== undefined &&
        errsList["socialMediaHandles,facebook"] !== null &&
        errsList["socialMediaHandles,facebook"] !== ""
      ) {
        err = message.VALID_URL;
      }
    }
    if (field === "twitter") {
      if (
        errsList["socialMediaHandles,twitter"] !== undefined &&
        errsList["socialMediaHandles,twitter"] !== null &&
        errsList["socialMediaHandles,twitter"] !== ""
      ) {
        err = message.VALID_URL;
      }
    }
    if (field === "zillow") {
      if (
        errsList["socialMediaHandles,zillow"] !== undefined &&
        errsList["socialMediaHandles,zillow"] !== null &&
        errsList["socialMediaHandles,zillow"] !== ""
      ) {
        err = message.VALID_URL;
      }
    }
    if (field === "realtor") {
      if (
        errsList["socialMediaHandles,realtor"] !== undefined &&
        errsList["socialMediaHandles,realtor"] !== null &&
        errsList["socialMediaHandles,realtor"] !== ""
      ) {
        err = message.VALID_URL;
      }
    }

    return err;
  }

  /**
   * @desc function to check given email id is registered with system or not
   *
   */
  checkEmailExist(email) {
    APIUtil.getMethod(
      UrlConstants.emailCheckUrl + "?email=" + email,
      false
    ).then((response) => {
      if (response.data && response.data._id !== undefined) {
        if (response.data.isDeleted == true) {
          this.setState({ isEmailDeleted: true });
          this.setState({ isEmailExist: false });
        } else {
          this.setState({ isEmailExist: true });
          this.setState({ isEmailDeleted: false });
        }
      } else {
        this.setState({ isEmailExist: false });
        this.setState({ isEmailDeleted: false });
      }
    });
  }

  /**
   * check username is unique
   */
  checkUserNameIsunique(userName) {
    // console.log("username 454");
    APIUtil.getMethod(
      UrlConstants.usernameCheckUrl + "?username=" + userName,
      false
    ).then((response) => {
      // console.log("checkUserNameIsunique", response);
      if (response.status == 200) {
        if (response.data == "duplicate") {
          // set error as username duplicate

          this.setState({ userNameDuplicate: true });
        } else {
          this.setState({ userNameDuplicate: false });
        }
      }
    });
  }

  /**
   * check mobile is unique
   */
  CheckMobileunique(mobile) {
    //console.log("mobile", mobile);
    APIUtil.getMethod(
      UrlConstants.addContact +
        "/CheckEmailOrMobileUniqueatregistration?mobile=" +
        mobile,
      false
    ).then((response) => {
      // console.log(response.data);
      if (response.data.error == "Unauthorized") {
        this.setState({ mobileDuplicate: true });
      } else {
        this.setState({ mobileDuplicate: false });
      }
    });
  }
  setValueInState() {
    //console.log('personalInfo setValueInState getUserData',this.props.getUserData())
    this.state = {
      ...this.state,
      startDate: this.props.getUserData().licenseExpirationDate,
      agentDate: this.props.getUserData().agentLicenseExpirationDate,
      firstname: this.props.getUserData().firstname,
      username: this.props.getUserData().username,
      lastname: this.props.getUserData().lastname,
      email: this.props.getUserData().email,
      recoveryEmail: this.props.getUserData().recoveryEmail,
      password: this.props.getUserData().password,
      confirmPassword: this.props.getUserData().confirmPassword,
      mobileNumber: this.props.getUserData().mobileNumber,
      otherNumber: this.props.getUserData().otherNumber,
      knowAboutUs: this.props.getUserData().knowAboutUs,
      referralCode: this.props.getUserData().referralCode,
      socialMediaHandles: {
        facebook: this.props.getUserData().socialMediaHandles.facebook,
        twitter: this.props.getUserData().socialMediaHandles.twitter,
        instagram: this.props.getUserData().socialMediaHandles.instagram,
        zillow: this.props.getUserData().socialMediaHandles.zillow,
        realtor: this.props.getUserData().socialMediaHandles.realtor,
      },
      isBuyerAgentInviteByAdmin: this.props.getUserData()
        .isBuyerAgentInviteByAdmin,
    };
  }

  render() {
    let startDate = this.state.startDate;
    let agentDate = this.state.agentDate;
    this.setValueInState();
    // console.log("username", this.state.username);
    return (
      <div className="step-content">
        <h4 className="title-blue mb-3">Personal Information</h4>
        <Form className="form-sm">
          <Row>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>
                  Username<span style={{ color: "#FFFFFF" }}> *</span>
                </Form.Label>
                <Form.Control
                  maxLength="50"
                  defaultValue={this.state.username}
                  onChange={this.onChange.bind(this)}
                  name="username"
                  type="text"
                  size="lg"
                  onBlur={this.props.handleValidation("username")}
                />

                <Form.Text style={{ color: "#FFFFFF" }}>
                  {this.renderHelpText(
                    this.getErrorMsg("username", this.props.errors)
                  )}
                  {this.state.userNameDuplicate ? message.USER_NAME_EXISTS : ""}
                </Form.Text>
              </Form.Group>
            </Col>

            <Col xs={12} sm={6}>
              <Form.Group controlId="" />
            </Col>

            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>
                  First Name<span style={{ color: "#FFFFFF" }}> *</span>
                </Form.Label>
                <Form.Control
                  maxLength="50"
                  defaultValue={this.state.firstname}
                  className="field_ucfirst"
                  onChange={this.onChange.bind(this)}
                  name="firstname"
                  type="text"
                  size="lg"
                  onBlur={this.props.handleValidation("firstname")}
                />

                <Form.Text style={{ color: "#FFFFFF" }}>
                  {this.renderHelpText(
                    this.getErrorMsg("firstname", this.props.errors)
                  )}
                  {this.state.validFirstName
                    ? message.ENTER_VALID_FIRST_NAME
                    : ""}
                </Form.Text>
              </Form.Group>
            </Col>

            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>
                  Last Name<span style={{ color: "#FFFFFF" }}> *</span>
                </Form.Label>
                <Form.Control
                  maxLength="50"
                  defaultValue={this.state.lastname}
                  className="field_ucfirst"
                  onChange={this.onChange.bind(this)}
                  name="lastname"
                  type="text"
                  size="lg"
                  onBlur={this.props.handleValidation("lastname")}
                />
                <Form.Text style={{ color: "#FFFFFF" }}>
                  {this.renderHelpText(
                    this.getErrorMsg("lastname", this.props.errors)
                  )}
                  {this.state.validLastName
                    ? message.ENTER_VALID_LAST_NAME
                    : ""}
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>
                  Email<span style={{ color: "#FFFFFF" }}> *</span>
                </Form.Label>
                <Form.Control
                  maxLength="50"
                  name="email"
                  defaultValue={this.state.email}
                  onChange={this.onChange.bind(this)}
                  type="email"
                  size="lg"
                  onBlur={this.props.handleValidation("email")}
                  disabled={this.state.isBuyerAgentInviteByAdmin ? true : false}
                />
                <Form.Text style={{ color: "#FFFFFF" }}>
                  {this.renderHelpText(
                    this.getErrorMsg("email", this.props.errors)
                  )}
                </Form.Text>
                {this.state.isEmailDeleted && (
                  <Form.Text style={{ color: "#FFFFFF" }}>
                    {this.renderHelpText(
                      "User already exists."
                    )}
                  </Form.Text>
                )}
                {this.state.isEmailExist && (
                  <Form.Text style={{ color: "#FFFFFF" }}>
                    {this.renderHelpText("Email already exists")}
                  </Form.Text>
                )}
              </Form.Group>
            </Col>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>
                  Confirm Email<span style={{ color: "#FFFFFF" }}> *</span>
                </Form.Label>
                <Form.Control
                  maxLength="50"
                  name="recoveryEmail"
                  defaultValue={this.state.recoveryEmail}
                  onChange={this.onChange.bind(this)}
                  type="email"
                  size="lg"
                  onBlur={this.props.handleValidation("recoveryEmail")}
                  disabled={this.state.isBuyerAgentInviteByAdmin ? true : false}
                />
                <Form.Text style={{ color: "#FFFFFF" }}>
                  {this.renderHelpText(
                    this.getErrorMsg("recoveryEmail", this.props.errors)
                  )}
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>
                  Password<span style={{ color: "#FFFFFF" }}> *</span>
                </Form.Label>
                <Form.Control
                  maxLength="50"
                  defaultValue={this.state.password}
                  onChange={this.onChange.bind(this)}
                  name="password"
                  type="password"
                  size="lg"
                  onBlur={this.props.handleValidation("password")}
                />
                <Form.Text style={{ color: "#FFFFFF" }}>
                  {this.renderHelpText(
                    this.getErrorMsg("password", this.props.errors)
                  )}
                  {this.state.validPassword ? message.ENTER_VALID_PASSWORD : ""}
                </Form.Text>
              </Form.Group>
            </Col>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>
                  Confirm Password<span style={{ color: "#FFFFFF" }}> *</span>
                </Form.Label>
                <Form.Control
                  maxLength="50"
                  defaultValue={this.state.confirmPassword}
                  onChange={this.onChange.bind(this)}
                  name="confirmPassword"
                  type="password"
                  size="lg"
                  onBlur={this.props.handleValidation("confirmPassword")}
                />
                <Form.Text style={{ color: "#FFFFFF" }}>
                  {this.renderHelpText(
                    this.getErrorMsg("confirmPassword", this.props.errors)
                  )}{" "}
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>
                  Mobile No.<span style={{ color: "#FFFFFF" }}> *</span>
                </Form.Label>
                <InputMask
                  mask="999-999-9999"
                  maskChar=""
                  formControlProps={{
                    fullWidth: true,
                  }}
                  className="form-control form-control-lg"
                  value={this.state.mobileNumber + ""}
                  name="mobileNumber"
                  onChange={this.onChange.bind(this)}
                  onBlur={this.props.handleValidation("mobileNumber")}
                >
                  {(inputProps) => <Form.Control {...inputProps} />}
                </InputMask>

                <Form.Text style={{ color: "#FFFFFF" }}>
                  {this.renderHelpText(
                    this.getErrorMsg("mobileNumber", this.props.errors)
                  )}
                  {this.state.mobileDuplicate
                    ? message.MOBILE_NUMBER_EXISTS
                    : ""}
                </Form.Text>
              </Form.Group>
            </Col>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Phone No. (Office)</Form.Label>
                <InputMask
                  mask="999-999-9999"
                  maskChar=""
                  formControlProps={{
                    fullWidth: true,
                  }}
                  className="form-control form-control-lg"
                  value={this.state.otherNumber}
                  name="otherNumber"
                  onChange={this.onChange.bind(this)}
                >
                  {(inputProps) => <Form.Control {...inputProps} />}
                </InputMask>

                <Form.Text style={{ color: "#FFFFFF" }}>
                  {this.renderHelpText(
                    this.getErrorMsg("otherNumber", this.props.errors)
                  )}
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>How did you hear about us?</Form.Label>
                <div className="c-select">
                  <select
                    onChange={this.onChange.bind(this)}
                    value={this.state.knowAboutUs}
                    name="knowAboutUs"
                    className="form-control form-control-lg"
                  >
                    <option value="">Select</option>
                    {this.props.hearAboutUs &&
                      this.props.hearAboutUs.length > 0 &&
                      this.props.hearAboutUs.map((option,index) => {
                        return (
                          <option value={option.lookUpValue} key={option._id}>
                            {option.displayName}
                          </option>
                        );
                      })}
                  </select>
                </div>
              </Form.Group>
            </Col>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Referral Code</Form.Label>
                <Form.Control
                  maxLength="50"
                  defaultValue={this.state.referralCode}
                  className="field_ucfirst"
                  onChange={this.onChange.bind(this)}
                  name="referralCode"
                  type="text"
                  size="lg"
                  onBlur={this.props.handleValidation("referralCode")}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Facebook URL</Form.Label>
                <Form.Control
                  maxLength="50"
                  defaultValue={this.state.socialMediaHandles.facebook}
                  onChange={this.onChange.bind(this)}
                  name={"socialMediaHandles.facebook"}
                  type="text"
                  size="lg"
                />
                <Form.Text style={{ color: "#FFFFFF" }}>
                  {this.renderHelpText(
                    this.getErrorMsg("facebook", this.props.errors)
                  )}
                </Form.Text>
              </Form.Group>
            </Col>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>Instagram URL</Form.Label>
                <Form.Control
                  maxLength="50"
                  defaultValue={this.state.socialMediaHandles.twitter}
                  onChange={this.onChange.bind(this)}
                  name={"socialMediaHandles.twitter"}
                  type="text"
                  size="lg"
                />
                <Form.Text style={{ color: "#FFFFFF" }}>
                  {this.renderHelpText(
                    this.getErrorMsg("twitter", this.props.errors)
                  )}
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}

PersonalInfo.propTypes = {
  errors: PropTypes.object,
  validate: PropTypes.func,
  isValid: PropTypes.func,
  handleValidation: PropTypes.func,
  getValidationMessages: PropTypes.func,
  clearValidations: PropTypes.func,
  getUserData: PropTypes.func,
  updateUserData: PropTypes.func,
};

export default validation(strategy)(PersonalInfo);
